import { cn } from "@/lib/utils";

const BASE_CLASS =
  "inline-flex items-center gap-1.5 rounded-full border font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50";

export type ChipSize = "sm" | "md";

const SELECTED_CLASS: Record<"true" | "false", string> = {
  true: "border-primary-500/40 bg-primary-50 text-primary-700 shadow-xs",
  false:
    "border-surface-200 bg-surface-0 text-surface-600 shadow-xs hover:border-surface-300 hover:bg-surface-50 hover:text-surface-900 dark:hover:bg-surface-100",
};

const SIZE_CLASS: Record<ChipSize, string> = {
  sm: "h-7 px-2.5 text-xs",
  md: "h-8 px-3 text-[13px]",
};

export function chipVariants({
  selected = false,
  size = "md",
  className,
}: {
  selected?: boolean;
  size?: ChipSize;
  className?: string;
} = {}): string {
  return cn(
    BASE_CLASS,
    SELECTED_CLASS[selected ? "true" : "false"],
    SIZE_CLASS[size],
    className,
  );
}

export function chipClass(selected: boolean, className?: string): string {
  return chipVariants({ selected, className });
}
